import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
  })
  
export class AuthenticationService {

    constructor(
    ) { }

    clearUserDataFromLocalStorage() {
        localStorage.clear();
    }

    redirectToCentralLogout() {
        window.location.href = environment.azuread.logoutURL;
    }

    logout() {
        this.clearUserDataFromLocalStorage();
        this.redirectToCentralLogout();
    }


    updateUserApplications(apps) {
        if(apps.length > 0){
            localStorage.setItem("user_apps", JSON.stringify(apps));
            localStorage.setItem("application", JSON.stringify(apps[0]));
        }
    }

    getUserApplications(): [] {
        return localStorage.getItem("user_apps") ? JSON.parse(localStorage.getItem("user_apps")) : '';
    }

    setUserApplication(appId: string): void {
        localStorage.setItem("application", appId);
    }

    getCurrentUserApplication() {
        return localStorage.getItem("application") ? JSON.parse(localStorage.getItem("application")) : '';
    }
}